import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
import ImgIconComp from './imgcomp';
import AddCustomAttr from './popup/addCustomAttr';
import AddCatgeory from './popup/addCatgeory';

class SelectedCustomAttributes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: 2,
      attributes: this.props.attrs.CustomAttr.custom_attribs,
      menuShow: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.clickArrow = this.clickArrow.bind(this);
    this.clickShowList = this.clickShowList.bind(this);
    this.selFieldType = this.selFieldType.bind(this);
    this.editCustomAttr = this.editCustomAttr.bind(this);
    this.saveCustomAttr = this.saveCustomAttr.bind(this);
    this.cancelBoxCustomAttr = this.cancelBoxCustomAttr.bind(this);
    this.deleteAttribute = this.deleteAttribute.bind(this);
    this.deleteCustomAttributes = this.deleteCustomAttributes.bind(this);
    this.clicMenu = this.clicMenu.bind(this);
    this.editCategory = this.editCategory.bind(this);
    this.saveCatgeory = this.saveCatgeory.bind(this);
    this.cancelBoxaddCatgeory = this.cancelBoxaddCatgeory.bind(this);
    this.deleteCategory = this.deleteCategory.bind(this);
    this.deleCatConfm = this.deleCatConfm.bind(this);
    this.cancelBoxDelCatgeory = this.cancelBoxDelCatgeory.bind(this);
  }

  componentDidMount() {
    const attributes = this.props.attrs.CustomAttr.custom_attribs.map((item) => {
      item.attributes.map((cat) => {
        cat.display = 0;
      });
      item.display = 1;
      return item;
    });
    this.setState({
      attributes,
    });
    window.addEventListener('click', this.handleClick, true);
  }

  handleClick(e) {
    const _this = this;
    if ((!$('.popupClcik').is(e.target) && $('.popupClcik').has(e.target).length === 0)) {
      const attributes = this.props.attrs.CustomAttr.custom_attribs.map((item) => {
        item.attributes.map((cat) => {
          cat.display = 0;
        });
        return item;
      });
      setTimeout(() => {
        _this.setState({
          attributes,
          menuShow: false,
        });
      }, 5);
    }
  }

  clickArrow(id, status) {
    const status_ = (status == undefined) ? false : !status;
    console.log(`${status_}: status_`);
    const attributes = this.props.attrs.CustomAttr.custom_attribs.map((item) => {
      if (item.id == id) {
        item.display = status_;
      }
      return item;
    });
    this.setState({
      attributes,
    });
  }

  clickShowList(pid, cid) {
    const _this = this;
    const attributes = this.props.attrs.CustomAttr.custom_attribs.map((item) => {
      if (item.id == pid) {
        item.attributes.map((cat) => {
          if (cat.id == cid) {
            const st = cat.display;
            cat.display = !st;
          }
        });
      }
      return item;
    });
    setTimeout(() => {
      _this.setState({
        attributes,
      });
    }, 5);
  }

  selFieldType() {
    const _this = this;
    const attributes = this.props.attrs.CustomAttr.custom_attribs.map((item) => {
      item.attributes.map((cat) => {
        cat.display = 2;
      });
      return item;
    });
    setTimeout(() => {
      _this.setState({
        attributes,
      });
    }, 6);
  }

  editCustomAttr(e, attrs, catName) {
    const { t } = this.props;
    const tableProps = {
      title: t('Edit a Custom Workstream Attribute'),
      buttons: {
        save: {
          name: t('Save'),
          color: 'red',
          callBack: this.saveCustomAttr,
        },
        cancel: {
          name: 'cale',
          color: 'black',
          callBack: this.cancelBoxCustomAttr,
        },
      },
      type: 2,
      category: this.props.attrs.CustomAttr.category,
      name: attrs.name,
      categoryName: catName,
      cat_id: attrs.cat_id,
      field_type_id: attrs.field_type_id,
      value: '',
      editPermission: '',
      viewPermission: '',
      selEditId: [],
      selEdit: [],
      selVisibId: [],
      selVisib: [],
      id: attrs.id,
      selshowFieldVal: attrs.field_type,
      values: attrs.values,
    };

    ReactDOM.render(<AddCustomAttr cancel={this.cancelBoxCustomAttr} tableProps={tableProps} />, document.getElementById('addCustomAttr'));
    addCustomAttr.dialogOpen();
  }

  saveCustomAttr(data) {
    const loginId = this.props.attrs.CustomAttr.loginUserID;
    const { teamId } = this.props.attrs.CustomAttr;
    this.cancelBoxCustomAttr(addCustomAttr);
    const { object_type } = this.props.attrs.CustomAttr;
    if (data != '') {
      const { actions } = this.props.attrs;
      const name = '';
      const field_type_id = '';
      const object_id = teamId;
      const cat_id = '';
      const categoryName = '';
      const created_by = loginId;
      const params = {
        object_type,
        object_id,
        name: data.attributeName,
        field_type_id: data.selshowFieldId,
        cat_id: data.selCatId,
        categoryName: data.selCat,
        created_by,
        id: data.id,
      };

      if (data.selshowFieldId == 3 || data.selshowFieldId == 4) {
        params.value = data.values;
      }
      if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
        params.YII_CSRF_TOKEN = $.ajaxSetup().data.YII_CSRF_TOKEN;
      }
      $.post(`${wbConfig.baseUrl}/activity/addCustomAttributes`, params, (response, status) => {
        if (status == 'success') {
          const oldCatId = (data.oldCatId != null) ? data.oldCatId : -1;
          const selCatId = (data.selCatId != null) ? data.selCatId : -1;
          actions.customEditAttributes(data.id, selCatId, response.data, oldCatId);
          if (selCatId != oldCatId) {
            actions.customDeleteAttributes(data.id, 2, oldCatId);
          }
        }
      });
    }
  }

  cancelBoxCustomAttr() {
    if (document.getElementById('addCustomAttr')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('addCustomAttr'));
    }
    $(addCustomAttr).dialog('close');
  }

  deleteAttribute(id, cat_id) {
    const typeDelete = 2;
    delete_meeting_confirm.dialog('open');
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    ReactDOM.render(<ViewDeletePopup id={id} cat_id={cat_id} deleteCustomCategory={this.deleteCustomAttributes} typeDelete={typeDelete} t={t} />, document.getElementById('delete-meeting-confirm-box'));
  }

  deleteCustomAttributes(id, typeDelete, cat_id) {
    const { actions } = this.props.attrs;
    const { object_type } = this.props.attrs.CustomAttr;
    const object_id = this.props.attrs.CustomAttr.teamId;
    $.post(`${wbConfig.baseUrl}/activity/deleteCustomAttributes`, { id, object_type, object_id }, (response, status) => {
      actions.customDeleteAttributes(id, typeDelete, cat_id);
    });
  }

  clicMenu(id) {
    this.setState({
      menuShow: id,
    });
  }

  editCategory(data) {
    const property = { /* pass json to AddCatgeory componet */
      title: t('Edit Category'), // title of the popup
      callBack: this.saveCatgeory, // save/callback methord
      cancel: this.cancelBoxaddCatgeory, // cancel/close button
      id: data.id,
      name: data.name, // Category Name in case of edit
      description: data.description, // Description in case of edit
    };
    ReactDOM.render(<AddCatgeory property={property} />, document.getElementById('addCatgeory'));
    addCatgeory.dialog('open');
  }

  saveCatgeory(data) {
    const { teamId } = this.props.attrs.CustomAttr;
    const { object_type } = this.props.attrs.CustomAttr;
    const { actions } = this.props.attrs;
    showLoaderWidget($('#content'));
    const params = {
      id: data.id, name: data.name, description: data.description, object_type, object_id: teamId,
    };
    $.post(`${wbConfig.baseUrl}/activity/addCustomCategory`, params, (response, status) => {
      if (status == 'success') {
        removeLoaderWidget();
        actions.customCategoryEdit(data.id, data.name, data.description);
      }
    });
    this.cancelBoxaddCatgeory();
  }

  cancelBoxaddCatgeory() {
    if (document.getElementById('addCatgeory')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('addCatgeory'));
    }
    $(addCatgeory).dialog('close');
  }

  deleteCategory(item) {
    ReactDOM.render(<DeleteCatgeory deleCatConfm={this.deleCatConfm} cancelBoxDelCatgeory={this.cancelBoxDelCatgeory} item={item} t={t} />, document.getElementById('deleteCatgeory'));
    deleteCatgeory.dialog('open');
  }

  deleCatConfm(data) { // delet cat
    const { id } = data;
    const object_id = this.props.attrs.CustomAttr.teamId;
    const { object_type } = this.props.attrs.CustomAttr;
    const { actions } = this.props.attrs;
    const params = {
      id,
      object_id,
      object_type,

    };
    if (data.selectedOption == 0) { // Delete category but keep custom attributes
      params.del_type = 0;
    } else if (data.selectedOption == 1) { // Delete category and delete all the custom attributes in the category
      params.del_type = 1;
    }
    if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
      params.YII_CSRF_TOKEN = $.ajaxSetup().data.YII_CSRF_TOKEN;
    }

    this.setState({
      attributes: this.props.attrs.CustomAttr.custom_attribs,
    });
    actions.customDeleteCategory(id, params.del_type);
    $.post(`${wbConfig.baseUrl}/activity/deleteCustomCategory`, params, (response, status) => {

    });
    this.cancelBoxDelCatgeory();
  }

  cancelBoxDelCatgeory() {
    if (document.getElementById('deleteCatgeory')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('deleteCatgeory'));
    }
    $(deleteCatgeory).dialog('close');
  }

  render() {
    let attributes = this.props.attrs.CustomAttr.custom_attribs;
    attributes = attributes.sort((a, b) => b.id - a.id);
    attributes = attributes.map((item) => {
      item.attributes.sort((a, b) => b.id - a.id);
      return item;
    });
    // console.log(attributes);
    // console.log("___!!!____");
    return (


      <div className="createdAttrWrap">

        {
                        attributes.map((item, index) => (
                          <div className="createdAttrSub" key={item.id}>
                            <div className="headSec">
                              <div className="attrName truncateText" title={item.name}>{item.name}</div>

                              <div className="buttonsLeft">
                                {
                                        item.attributes.length > 0
                                        && (
                                        <div className="arraow" onClick={e => this.clickArrow(item.id, item.display)}>
                                          <ImgIconComp id={item.display || typeof item.display === 'undefined' ? 'arrow_up_gray' : 'arrow_down_gray'} width="13" height="10" />
                                        </div>
                                        )
                                        }
                                { item.id != -1
                                  ? (
                                    <div className="threeDotMenuWrap popupClcik">
                                      <div onClick={e => this.clicMenu(item.id)}>
                                        <ImgIconComp id="kebab_menu" width="5" height="15" />
                                        { this.state.menuShow == item.id ? <ThreeDotMenuPopup editCategory={this.editCategory} deleteCategory={this.deleteCategory} item={item} t={t} /> : ''}
                                      </div>
                                    </div>
                                  )
                                  : ''
                                        }
                              </div>
                              <div className="border" />
                            </div>
                            {
                                (item.display == 1 || typeof item.display === 'undefined')

                                  ? item.attributes.map((attrs, aIndex) => (
                                    <div key={attrs.id} className="boadsec" id="0">
                                      <div className="block filedName ">
                                        <div className="truncateText filedNamediv" title={attrs.name}>{attrs.name}</div>
                                      </div>
                                      <div className="block filedType">{attrs.field_type}</div>

                                      <div className="block fields">
                                        { (attrs.field_type_id == 3 || attrs.field_type_id == 4)
                                          ? (
                                            <div style={{ padding: '0px' }} className="block dropdown popupClcik" onClick={e => this.clickShowList(item.id, attrs.id)}>
                                              <div className="selFieldType">
                                                <div style={{ display: 'inline-block' }}>{t('Dropdown List')} </div>
                                                <ImgIconComp class="dropDIcon" id="arrow_down_gray" width="13" height="10" />
                                              </div>
                                              { (attrs.display == 1 && (attrs.values).length > 0)
                                                ? <FieldDropDownList selFieldType={this.selFieldType} fields={attrs.values} /> : ''
                                                  }
                                            </div>
                                          )
                                          : ''
                                                }
                                      </div>


                                      <div className="block editButton" onClick={e => this.editCustomAttr(e, attrs, item.name)}><ImgIconComp id="edit_image" width="13" height="13" /></div>
                                      <div className="block deleteButton" onClick={e => this.deleteAttribute(attrs.id, item.id)}><ImgIconComp id="delete_image3X" width="20" height="20" /></div>
                                      <div className="border" />
                                    </div>
                                  )) : ''
                              }
                          </div>
                        ))

                    }
      </div>
    );
  }
}

const FieldTypeSelect = ({ t, ...props }) => (
  <div className="typeSelectWrap">
    <div data-value="1" className="option popupClcik" onClick={e => props.selFieldType(null, 'N/A')}>{t('Text field')}</div>
    <div data-value="1" className="option popupClcik" onClick={e => props.selFieldType(1, t('Text field'))}>{t('Text field')}</div>
    <div data-value="2" className="option popupClcik" onClick={e => props.selFieldType(2, t('Text Area'))}>{t('Text Area')}</div>
    <div data-value="3" className="option popupClcik" onClick={e => props.selFieldType(3, t('Dropdown List'))}>{t('Dropdown List')}</div>
    <div data-value="4" className="option popupClcik" onClick={e => props.selFieldType(4, t('Multi-select Dropdown'))}>{t('Multi-select Dropdown')}</div>
  </div>
);


class FieldDropDownList extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const selFieldType = this.props.fields;

    // console.log(this.props.fields);
    // console.log("selFieldType");
    const lis = [];
    for (let i = 0; i < selFieldType.length; i++) {
      lis.push(<div className="option popupClcik" onClick={e => this.props.selFieldType()}>{selFieldType[i]}</div>);
    }
    return (
      <div className="typeSelectWrap  verticalScroll">
        { lis
                    }
      </div>
    );
  }
}

class ViewDeletePopup extends React.Component {
  constructor(props) {
    super(props);
    this.closeWsPopup = this.closeWsPopup.bind(this);
    this.deleteMeetingPopUp = this.deleteMeetingPopUp.bind(this);
  }

  closeWsPopup() {
    $(delete_meeting_confirm).dialog('close');
  }

  deleteMeetingPopUp() {
    const obj = $(this).closest('#delete-meeting-confirm-box');
    // this.props.deleteMeeting();
    this.props.deleteCustomCategory(this.props.id, typeDelete, this.props.cat_id);
    this.closeWsPopup();
  }

  render() {
    const { typeDelete, t } = this.props;
    let headName = '';
    if (typeDelete == 1) {
      headName = t('category');
    } else if (typeDelete == 2) {
      headName = t('attributes');
    }
    return (
      <div className="wbmodal" id="delete-meeting-confirm-box">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>
{t('Delete')}
              {headName}
            </b>
          </div>
          <div className="wbmodal-hcancel closeWsPopup right clickable" onClick={this.closeWsPopup}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content" style={{ padding: '20px 30px' }}>
          <div>
            <span>
              {' '}
{t('Are you sure you want to delete this')}
              {headName}
              {' '}
?
            </span>
          </div>
          <div className="gbl-butn-wraper" style={{ float: 'right', width: '56px' }}>
            <div className="gbl-btn" data-id={this.props.id} onClick={this.deleteMeetingPopUp}>{t('Yes')}</div>
          </div>
        </div>
      </div>
    );
  }
}

class ThreeDotMenuPopup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="menuWrap">
        <div className="menu" onClick={e => this.props.editCategory(this.props.item)}>
                    {t('Edit Category')}
        </div>
        <div className="menu" onClick={e => this.props.deleteCategory(this.props.item)}>
                   {t('Delete')}
        </div>
      </div>
    );
  }
}

class DeleteCatgeory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: '0',
      id: this.props.item.id,
    };
    this.clickChkBox = this.clickChkBox.bind(this);
    this.saveValues = this.saveValues.bind(this);
  }

  clickChkBox(e) {
    this.setState({
      selectedOption: e.target.value,
    });
  }

  saveValues() {
    this.props.deleCatConfm(this.state);
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="custmHead ">
          <div className="popupWrap">
            <div className="headLable">{t('Delete Category')}</div>
            <div className="headClose" onClick={e => this.props.cancelBoxDelCatgeory()}>
              {' '}
              <img className="closeX" src={`${wbConfig.baseUrl}/images/ai-v1-assets/x.png`} />
            </div>
          </div>
        </div>

        <div className="AddWsCustmBoay ">
          <div className="popupWrap">
            <div className="col">
              <div className="lable">{t('Are you sure you want to delete this category? If so, you have the following two options?')}</div>
            </div>


            <div className="col descrp">
              <input type="radio" value="0" className="inputRedio" onChange={this.clickChkBox} checked={this.state.selectedOption === '0'} />
              <div className="lable">{t('Delete category but keep custom attributes')}</div>
            </div>

            <div className="col descrp">
              <input type="radio" value="1" className="inputRedio" onChange={this.clickChkBox} checked={this.state.selectedOption === '1'} />
              <div className="lable">{t('Delete category and delete all the custom attributes in the category')}</div>
            </div>

          </div>
        </div>


        <div className="AddWsCustmBtn ">
          <div className="delete" onClick={e => this.saveValues()}>{t('Delete')}</div>
          <div className="cansel" onClick={e => this.props.cancelBoxDelCatgeory()}>{t('Cancel')}</div>
        </div>

      </div>
    );
  }
}

export default withTranslation()(SelectedCustomAttributes);
